import TRLocales from "./tr-TR";
import ENLocales from "./en-US";

export const AllLocales = {
    ...TRLocales,
    ...ENLocales
}

export default AllLocales
